export const loginConfig = {
  newCDN: 1,
  version: 4,
  swidth: 320,
  includeBox: 'mobileLogin',
  domains: 'vip.126.com,163.com,126.com,youdao.com,huihui.cn',
  needMobileLogin: 1,
  cookieDomain: 'youdao.com',
  isHttps: 1,
  skin: 0,
  needUnLogin: 1,
  defaultUnLogin: 1,
  unLoginTime: 30,
  unLoginText: '三十天内免登录',
  needPrepare: 1,
  mode: 'float',
  page: 'login',
  capPadding: 2,
  single: 1,
  style: '.mbItlBox input.dlemail{padding-left: 68px;}.country{ text-align: center;width: 65px;  background-position: -336px -340px;}#changepage {display: none;}.m-cnt .u-logo div{margin-top: 14px;}.m-cnt .u-success{margin-top: 16px;}.m-cnt .inputbox{height: 48px;}.m-cnt .u-input input{    margin-top: 13px !important;}.country{top:4px}.m-cnt .pcbtn a{height:48px;line-height: 48px;.m-cnt .u-success{margin-top: 16x;}}.m-cnt .m-nerror{margin-top: 12px;}.loginbox{    margin-top: 20px;}.u-loginbtn{height:48px;line-height: 48px;}.mbtoggleitl-box{top: 3px;}',
  cssDomain: 'https://c.youdao.com/dict/common/',
  // cssDomain,
  capBarHeight: 40,
  cssFiles: `override.css?v=${new Date().getTime()}`,
  mobilePlaceholder: { mobile: '请输入手机号码', pwd1: '请输入密码' },
  customStyles: { imagePanel: { align: 'bottom' } },
  mobileFirst: 1,
  smsLoginFirst: 1,
  mbNeedItl: 1,
  noqr: 1,
  mobileUnLoginTime: 30,
  mobileDefaultUnLogin: 1,
  mobileUnLoginTimeTxt: '三十天内免登录',
  // mailloginclause: {
  //   list: [
  //     {
  //       url: 'https://reg.163.com/agreement_mobile.shtml',
  //       txt: '条款1',
  //     },
  //     {
  //       url: 'https://reg.163.com/agreement_mobile.shtml',
  //       txt: '条款2',
  //     },
  //   ],
  //   clauseErr: '请同意服务条款'
  // },
  goEmailLoginTxt: '网易邮箱',
  goMbLoginTxt: '手机验证码',
  uniteLogin: {
    clause: 1,
    // needClause: 1,
    // noClauseForce: 1,
    preFillUnite: 14e9,
    needUnLogin: 1,
    defaultUnLogin: 1,
    unLoginTime: 30,
    unLoginDefautl: 1,
    unLoginTxt: '三十天内免登录',
    terms0: '《服务条款》',
    terms0Link: '//reg.163.com/agreement_mobile.shtml',
    terms1: '《隐私政策》',
    terms1Link: '//reg.163.com/agreement_mobile_ysbh.shtml',
    loginTxt: '登 录',
    isItl: 1,
    first: 1,
    placeholders: { mob: '请输入手机号码', sms: '请输入验证码' },
  },
  // 登录成功后回调
};

export default null;
